import { setDataMiningOnSessionStorage } from '~/modules/integrations/datamining/composables/useDataMiningComposable'

export default defineNuxtRouteMiddleware(async to => {
  // skip middleware on server
  if (import.meta.server) return

  const isAdminRoute = to.matched.some(
    matchedRoute => matchedRoute.meta.AuthAdmin === true,
  )
  if (!isAdminRoute) {
    await setDataMiningOnSessionStorage()
  }
  return
})
